import React, { FC } from 'react';
import PencilSvg from 'assets/image/pencil-light.svg';
import styles from './ButtonPencil.module.scss';
import cx from 'classnames';

type ButtonPencilProps = {
	clickHandler: () => void;
	parentClassName?: string;
};

const ButtonPencil: FC<ButtonPencilProps> = ({ clickHandler, parentClassName }: ButtonPencilProps) => {
	return (
		<button className={cx(styles.main, parentClassName)} onClick={clickHandler}>
			<img className={styles.icon} src={PencilSvg} alt="pencil" />
		</button>
	);
};

export default ButtonPencil;
